/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { notificationMarkAllAsRead } from '../../axios/notificationMarkAllAsRead'
import type {
	NotificationMarkAllAsReadError,
	NotificationMarkAllAsReadResponse,
} from '../../types/NotificationMarkAllAsRead'

export const notificationMarkAllAsReadMutationKey = () => [{ url: '/notifications/read-all' }] as const

export type NotificationMarkAllAsReadMutationKey = ReturnType<typeof notificationMarkAllAsReadMutationKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::markAllAsRead */
export function useNotificationMarkAllAsRead<TContext = unknown>(
	options?: UseMutationOptions<
		NotificationMarkAllAsReadResponse,
		AxiosError<NotificationMarkAllAsReadError>,
		void,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: notificationMarkAllAsReadMutationKey(),
		mutationFn: () => notificationMarkAllAsRead(config).then(res => res.data),
		...options,
	})
}
